"use client";

import { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { getUniverseData } from "@/lib/api";
import type { UniverseData } from "@/lib/types";
import { Loader2 } from "lucide-react";

const UniverseScene = dynamic(
  () => import("@/components/three/UniverseScene"),
  {
    ssr: false,
    loading: () => (
      <div
        className="flex items-center justify-center w-full h-screen"
        style={{ background: "#050510" }}
      >
        <div className="text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <Loader2 size={24} className="animate-spin" style={{ color: "#c8a45e" }} />
            <span style={{ color: "#e8e0d0" }} className="text-base">
              Initializing universe...
            </span>
          </div>
          <p style={{ color: "rgba(232, 224, 208, 0.4)" }} className="text-xs">
            Loading ~31,000 verse positions
          </p>
        </div>
      </div>
    ),
  }
);

export default function UniversePage() {
  const [data, setData] = useState<UniverseData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getUniverseData()
      .then(setData)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (error) {
    return (
      <div
        className="flex items-center justify-center h-screen"
        style={{ background: "#050510" }}
      >
        <div className="text-center">
          <p style={{ color: "#e8e0d0" }} className="text-lg mb-2">
            Failed to load universe
          </p>
          <p style={{ color: "rgba(232, 224, 208, 0.5)" }} className="text-sm">
            {error}
          </p>
        </div>
      </div>
    );
  }

  if (loading || !data) {
    return (
      <div
        className="flex items-center justify-center h-screen"
        style={{ background: "#050510" }}
      >
        <div className="text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <Loader2 size={24} className="animate-spin" style={{ color: "#c8a45e" }} />
            <span style={{ color: "#e8e0d0" }} className="text-base">
              Loading Bible Universe...
            </span>
          </div>
          <p style={{ color: "rgba(232, 224, 208, 0.4)" }} className="text-xs">
            Preparing 31,102 verse-stars
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen">
      <UniverseScene data={data} />
    </div>
  );
}
